import {
  DangerIcon_default
} from "./chunk-6UQX6BHS.mjs";
export {
  DangerIcon_default as default
};
